// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__3Gl0E","list":"Tabs_list__1o0pF","tab":"Tabs_tab__2ooKq","active":"Tabs_active__rY3wq"};